@import '../../global/variables/grid';
:root {
  --lgr-modal-height: 100%;
  height: 100%;
}
.modal {
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  padding: var(--lgr-spacing-xxxs);
  background-color: rgba(51, 51, 51, var(--lgr-alpha-intense));
  box-sizing: border-box;
  overflow: hidden;

  &.is-open {
    display: flex;
  }

  &.full-size {
    @media (max-width: ($lgr-grid-md-break-point - 1)) {
      padding: 0;

      .modal-content {
        height: 100vh;
        max-height: 100vh;
        width: 100vw;
        max-width: 100vw;
        border-radius: unset;
        height: 100dvh !important;
        max-height: 100dvh !important;
        display: block;
        overflow: hidden;
        padding: 2rem;

        .text-wrapper {
          flex: 1;
        }
      }
    }
  }

  .modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: var(--lgr-spacing-xs);
    max-height: 696px;
    position: relative;
    background-color: var(--lgr-color-neutral-high-pure);
    padding: var(--lgr-spacing-xs);
    border-radius: var(--lgr-border-radius-lg);
    text-align: center;
    box-sizing: border-box;
    margin: 0;
    z-index: 1;

    lgr-icon.close {
      position: absolute;
      top: var(--lgr-spacing-xxxs);
      right: var(--lgr-spacing-xxxs);
      font-size: var(--lgr-font-size-xl);
      color: var(--lgr-color-brand-primary);
      cursor: pointer;
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      gap: var(--lgr-spacing-xs);
    }

    .button-wrapper {
      display: flex;
      justify-content: flex-end;
      width: 100%;

      lgr-button {
        width: 100%;
      }
    }

    @media (min-width: $lgr-grid-md-break-point) {
      width: 512px;
    }

    &-webform {
      padding-inline: var(--lgr-spacing-xxxs);

      .text-wrapper {
        overflow-y: auto;
        overflow-x: hidden;
      }

      @media (min-width: $lgr-grid-md-break-point) {
        width: 800px;
        max-height: fit-content;
        padding: var(--lgr-spacing-xs);
      }
    }
  }

  .modal-layer {
    position: fixed;
    width: 100%;
    height: 100%;
  }
}